import Chart from "../../components/chart/Chart";
import React from "react";
import { Link } from "react-router-dom";
import { productData } from "../../data/fakeProductChart";
import { Public } from "@material-ui/icons";
import "./product.css"
const Product = () => {
  return (
    <div className="product">
      <div className="product_title_container">
        <h1 className="product_title">Product</h1>
        <Link to="/new_product">
          <button className="product_add_button">Create</button>
        </Link>
      </div>

      <div className="product_top">
        <div className="product_top_left">
          <Chart data={productData} dataKey="Sales" title="Sales Performance" />
        </div>

        <div className="product_top_right">
          <div className="product_info_top">
            <img
              src="https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt=""
              className="product_info_img"
            />
            <span className="product_name">Apple Airpods</span>
          </div>
          <div className="product_info_buttom">
            <div className="product_info_item">
              <span className="product_info_key">id:</span>
              <span className="product_info_value">123</span>
            </div>
            <div className="product_info_item">
              <span className="product_info_key">id:</span>
              <span className="product_info_value">123</span>
            </div>
            <div className="product_info_item">
              <span className="product_info_key">id:</span>
              <span className="product_info_value">123</span>
            </div>
            <div className="product_info_item">
              <span className="product_info_key">id:</span>
              <span className="product_info_value">123</span>
            </div>
            <div className="product_info_item">
              <span className="product_info_key">id:</span>
              <span className="product_info_value">123</span>
            </div>
          </div>
        </div>
      </div>

      <div className="product_buttom">
        <form className="product_form">
          <div className="product_form_left">
            <label>Product Name</label>
            <input type="text" placeholder="Apple Airpods" />

            <label>In Stock</label>
            <select name="inStock" id="inStock">
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div className="product_form_right">
            <div className="product_upload">
              <img
                src="https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
                alt=""
                className="product_upload_img"
              />
              <label for="file">
                <Public />
              </label>
              <input type="file" id="file" style={{ display: "none" }} />
            </div>
            <button className="product_button">Update</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Product;
